import api from 'api'

export const removeDevolutive = async (id) => {
  const { data } = await api.delete(`/devolutive/${id}`)

  return data
}
